module.exports = __webpack_public_path__ + "static/media/chevron_right.ff70ecbe.svg";